import { GoogleLoginResponse } from 'react-google-login'

export enum LocalStorageItem {
  Token = 'dashboard-token',
  GoogleToken = 'google-token-v1',
  GoogleResponse = 'google-res-v1',
}

export class LocalStorage {
  static setGoogleAccount(res: GoogleLoginResponse): void {
    localStorage.setItem(LocalStorageItem.GoogleResponse, JSON.stringify(res))
  }
  static getGoogleAccount(): GoogleLoginResponse | null {
    const res = localStorage.getItem(LocalStorageItem.GoogleResponse)
    if (res) {
      return JSON.parse(res)
    } else return null
  }

  static setGoogleToken(token: string): void {
    localStorage.setItem(LocalStorageItem.GoogleToken, token)
  }

  static cleanGoogleToken(): void {
    localStorage.removeItem(LocalStorageItem.GoogleToken)
  }

  static getGoogleToken(): string | null {
    return localStorage.getItem(LocalStorageItem.GoogleToken)
  }
}
